<template>
    <div class="w-full">
        <div
            v-for="(item, index) in rows"
            :key="index"
            class="flex items-center gap-3 py-2 border-b border-theme-border"
        >
            <div class="flex-1 text-theme-base font-medium">
                {{ cityName(item.code) }}
            </div>
            <div class="w-40">
                <input-money-component
                    v-model="item.price"
                    border
                    :label="null"
                    icon="💲"
                    @input="emitChange"
                />
            </div>
            <button
                v-if="!fixedCode || item.code !== fixedCode"
                class="text-theme-danger hover:text-theme-danger p-1 rounded"
                @click="removeRow(index)"
            >
                🗑️
            </button>
        </div>

        <div v-if="availableCities.length" class="mt-3 flex items-end gap-2">
            <city-code-selector
                v-model="newCityCode"
                class="flex-1"
                @change="onCitySelected"
            />
            <app-button flat icon @click="addRow"> ➕ </app-button>
        </div>
    </div>
</template>

<script>
import { ENABLED_CITIES } from "@/common/constants";

import CityCodeSelector from "./CityCodeSelector.vue";
import InputMoneyComponent from "./InputMoneyComponent.vue";

export default {
    name: "CityPriceEditor",
    components: { CityCodeSelector, InputMoneyComponent },
    model: {
        prop: "value",
        event: "change"
    },
    props: {
        value: {
            type: Object,
            default: () => ({})
        },
        fixedCode: {
            type: String,
            default: null
        }
    },
    data() {
        return {
            rows: [],
            newCityCode: ""
        };
    },
    computed: {
        usedCodes() {
            return this.rows.map((r) => r.code);
        },
        availableCities() {
            return Object.entries(ENABLED_CITIES)
                .filter(([code]) => !this.usedCodes.includes(code))
                .map(([code, name]) => ({ code, name }));
        }
    },
    watch: {
        value: {
            immediate: true,
            handler(val) {
                this.rows = Object.entries(val || {}).map(([code, price]) => ({
                    code,
                    price
                }));
            }
        }
    },
    methods: {
        cityName(code) {
            return ENABLED_CITIES[code] || code;
        },
        onCitySelected(code) {
            this.newCityCode = code;
        },
        addRow() {
            if (!this.newCityCode) return;
            this.rows.push({ code: this.newCityCode, price: 0 });
            this.newCityCode = "";
            this.emitChange();
        },
        removeRow(index) {
            this.rows.splice(index, 1);
            this.emitChange();
        },
        emitChange() {
            const result = {};
            this.rows.forEach(({ code, price }) => {
                result[code] = price;
            });
            this.$emit("change", result);
        }
    }
};
</script>
